export const JOB_EVENTS_PAGE_QUERY_PARAM = "job_events_page";
